module.exports = __webpack_public_path__ + "static/media/anaAwardFuture-event.ce22884f.png";